const FitGuideModal = () => {

  // elements
  const els = {
    openButton: document.querySelectorAll('[data-fit-guide-modal-open]'),
    closeButton: document.querySelectorAll('[data-fit-guide-modal-close]'),
    modals: document.querySelectorAll('[data-fit-guide-modal]'),
    modal: null
  }

  const closeModal = () => {
    els.modal.classList.remove('active');
    document.body.style.overflow = '';
    setTimeout(() => {
      els.modal.style.display = 'none';
    }, 500)
  };

  const openModal = () => {
    document.body.appendChild(els.modal);
    els.modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      els.modal.classList.add('active');
    }, 500)
  };


  if (els.openButton) {
    els.openButton.forEach(el => {
      el.addEventListener('click', e => {
        els.modal = document.getElementById(e.currentTarget.dataset.fitGuideModalOpen);
        e.preventDefault();
        openModal();
      });
    });

    els.closeButton.forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        closeModal();
      });
    });

    els.modals.forEach(el => {
      el.addEventListener('click', e => {
        closeModal();
      });
    });
  }
};

export default FitGuideModal;